import { JOB_SEARCH_RESTORE_STORAGE_KEY } from "../navigation/scrollRestorePolicy";

/** True when UI state should restore list scroll / last-opened job instead of re-running search. */
export function isJobSearchRestoreUiState(ui) {
  if (!ui || typeof ui !== "object") return false;
  if (typeof ui.lastOpenedJobId === "string" && ui.lastOpenedJobId.trim()) return true;
  if (typeof ui.scrollY === "number" && Number.isFinite(ui.scrollY)) return true;
  if (ui.hasSearched && Array.isArray(ui.apiSearchJobs) && ui.apiSearchJobs.length > 0) return true;
  return false;
}

/** Read persisted job-search snapshot (set when opening a job from results). */
export function readJobSearchRestoreSnapshot() {
  if (typeof window === "undefined") return null;
  try {
    const raw = window.sessionStorage.getItem(JOB_SEARCH_RESTORE_STORAGE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (!parsed || typeof parsed !== "object") return null;
    return isJobSearchRestoreUiState(parsed) ? parsed : null;
  } catch {
    return null;
  }
}

/** Router `state` for Link/navigate back to `/job-search` with restore payload. */
export function jobSearchReturnRouterState(searchUiState) {
  if (!isJobSearchRestoreUiState(searchUiState)) return undefined;
  return { searchUiState, preserveScroll: true };
}

/** Resolve restore UI from router state (Link back) or session snapshot (browser Back). */
export function resolveJobSearchRestoreUi(location, navType) {
  const fromRouter = location?.state?.searchUiState;
  if (isJobSearchRestoreUiState(fromRouter)) return fromRouter;
  if (navType === "POP") return readJobSearchRestoreSnapshot();
  return null;
}

export function jobSearchRestoreScrollY(ui) {
  if (!ui || typeof ui !== "object") return null;
  const y = ui.scrollY;
  return typeof y === "number" && Number.isFinite(y) && y >= 0 ? y : null;
}
